// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__Y5Rps","image":"style_image__PnmRF","banner":"style_banner__qk6ce"};